import { IGetAllIndicadorObraUseCase } from "../../../presentation/useCases/read/get_all_indicador_obra_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IndicadorObra } from "../../models/indicador_obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllIndicadorObraUseCase
 */

export class GetAllIndicadorObraUseCase extends BasePaginatedUseCase<IndicadorObra> implements IGetAllIndicadorObraUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllIndicadorObra(
    idObra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllIndicadorObra(
        idObra,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
